const Backdrop = () => {
  return <div className='fixed top-0 left-0 w-full h-screen z-50 bg-gray-900 opacity-70'></div>;
};

export default Backdrop;
